import React from 'react';
import { UserResortProfile } from 'src/models/resort/UserResortProfile';
import { ResortMyPromotionContent } from '../promotion/ResortMyPromotionContent';
import { ResortOtherPromotionContent } from '../promotion/ResortOtherPromotionContent';

interface ResortDeepLinkUnlockedProps {
  profile: UserResortProfile;
  isMyself: boolean;
  isFollowing: boolean;
}

export const ResortDeepLinkUnlocked: React.FC<ResortDeepLinkUnlockedProps> = ({
  profile,
  isMyself,
  isFollowing
}) => {
  return isMyself ? (
    <ResortMyPromotionContent basePath={'/deep-link'} profile={profile} />
  ) : (
    <ResortOtherPromotionContent
      basePath={'/deep-link'}
      profile={profile}
      isFollowing={isFollowing}
    />
  );
};
